







































































import { Component, Prop, Watch, Inject, Vue } from "vue-property-decorator";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import UloadCroppingPictures from "@/components/app/images/upload-cropping-pictures.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { ICategory } from "@/@types/gallsery/gallery";
import { ILocale } from "@/@types/locale";

@Component({
  components: {
    CloseButton,
    SubmitResetButtonGroop,
    BSwitch,
    "upload-img": UloadCroppingPictures,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class GalleryCategoryForm extends Vue {
  @Inject("folder") readonly folder!: string;
  @Inject("foldersbg") readonly foldersbg!: string;
  @Prop({ type: Object, default: null }) item!: ICategory;

  activeLocale = this.$store.getters.getLanguages[0];

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  names: ILocale = {};
  show = true;
  background = "";
  poster = "";
  name = "";
  sort_order = 0;

  get getFormat(): ICategory {
    return {
      _id: this.item ? this.item._id : undefined,
      name: this.names,
      show: this.show,
      sort_order: this.sort_order,
      src: {
        bg: this.background,
        poster: this.poster,
      },
    };
  }

  @Watch("name")
  entryFolderName(): void {
    this.names[this.activeLocale] = this.name;
  }

  @Watch("activeLocale")
  folderName(): void {
    if (this.names)
      this.name = this.names[this.activeLocale]
        ? this.names[this.activeLocale]
        : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    this.$emit("uploadFolder", this.getFormat);
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.show = false;
  }

  formationUpdateParams(): void {
    if (!this.item || !this.item._id) return;
    this.names = Object.assign({}, this.item.name);
    this.show = this.item.show;
    this.sort_order = this.item.sort_order;
    this.poster = this.item.src.poster;
    this.background = this.item.src.bg;
    this.folderName();
  }

  mounted(): void {
    this.formationUpdateParams();
  }
}
